namespace Matrix.Data {
    export interface ModelTargetExportRequest extends Serenity.ServiceRequest {
        ModelCode?: string;
    }
}
